import Button from "@components/Button"
import resolvePrice from "@helpers/pricing"
import { Form } from "react-router-dom"
import { Plan, StripePrice } from "src/types"

interface Props {
  buttonClassName?: string
  buttonTitle: string
  currency: string
  isSubmitting: boolean
  plan: Plan
  setIsSubmitting: (isSubmitting: boolean) => void
  stripeFullPrice: StripePrice | undefined
  stripeIntroPrice: StripePrice | undefined
}

export default function SubscriptionForm({
  buttonClassName = "",
  buttonTitle,
  currency,
  isSubmitting,
  plan,
  setIsSubmitting,
  stripeFullPrice,
  stripeIntroPrice,
}: Props) {
  const fullPrice = resolvePrice({ currency, stripePrice: stripeFullPrice })

  // NOTE: The plan travels in the URL from here on (createStripeSubscription
  // action: plan, price_id, next_price_id), so it survives the return from
  // Stripe even when the browser blocks storage.
  const handleClick = () => {
    setIsSubmitting(true)
  }

  return (
    <Form onSubmit={handleClick} method="post">
      <input type="hidden" name="currency" value={currency} />
      <input type="hidden" name="fullPrice" value={fullPrice?.amountInCents} />
      <input type="hidden" name="nextPriceId" value={stripeFullPrice?.id} />
      <input type="hidden" name="plan" value={plan} />
      <input type="hidden" name="priceId" value={stripeIntroPrice?.id} />

      <Button
        className={buttonClassName}
        submitting={isSubmitting}
        title={buttonTitle}
        type="submit"
      />
    </Form>
  )
}
